import type { ReactNode } from 'react';

export const symbol_sd_card: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M434.5-536.63q8.5-8.62 8.5-21.37v-97q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v97q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63Zm119 0q8.5-8.62 8.5-21.37v-97q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v97q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63Zm119 0q8.5-8.62 8.5-21.37v-97q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v97q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63ZM220-80q-24 0-42-18t-18-42v-476q0-12.44 5-23.72T178-659l203-203q8-8 19.28-13 11.28-5 23.72-5h316q24 0 42 18t18 42v680q0 24-18 42t-42 18H220Zm0-60h520v-680H426L220-613.88V-140Zm0 0h520-520Z"
		/>
	</svg>
);
